const language = {
	spanish: {
		button_text: "COMIENCE A PROTEJER SU FLOTA",
	},
	english: {
		button_text: "START PROTECTING YOUR FLEET",
	},
};

export default language